/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Map_SkipInputs */

const cs_import_map_skip = /** @type {(inputs: Import_Map_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`— Přeskočit —`)
};

const en_import_map_skip = /** @type {(inputs: Import_Map_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`— Skip —`)
};

/**
* | output |
* | --- |
* | "— Skip —" |
*
* @param {Import_Map_SkipInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_map_skip = /** @type {((inputs?: Import_Map_SkipInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Map_SkipInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_map_skip(inputs)
	return cs_import_map_skip(inputs)
});